<template>
  <div>
    <PageAllow controller="Receipt" action="batchReceiveAndPay" />
    <Breadcrumbs :items="items" />
    <v-slide-x-transition>
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1">
              <SearcherDatetimeRangeWithRadio
                v-model="datetimeRage"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                removeIcon
              />
            </v-row>
          </v-col>

          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                {{ $t("Search.pro") }}
                <v-icon small class="ps-1">{{
                  $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <!-- 添加支付 -->
              <v-btn
                v-if="selectedObj.length == 1"
                :disabled="showSelect.length ? false : true"
                small
                color="primary"
                class="ms-1"
                @click="addPay()"
              >
                {{ $t("paymentBat.add") }}
              </v-btn>
              <v-btn
                v-else-if="selectedObj.length > 1"
                :disabled="showSelect.length ? false : true"
                small
                color="primary"
                class="ms-1"
                @click="addPays()"
              >
                {{ $t("paymentBat.add") }}
              </v-btn>
              <!-- 选择对象 -->
<!--              <v-btn-->
<!--                small-->
<!--                color="primary"-->
<!--                class="ms-1"-->
<!--                @click.stop="dialog = true"-->
<!--              >-->
<!--                {{ $t("paymentBat.Fields.obj_select") }}-->
<!--              </v-btn>-->
            </v-row>
          </v-col>
        </v-row>

        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4" class="d-flex align-center">
                  <v-text-field
                    :value="itemLabel"
                    label="对象*"
                    readonly
                  ></v-text-field>
                  <v-btn x-small color="primary" @click.stop="dialog = true">
                    {{ $t("paymentBat.Fields.obj_select") }}
                  </v-btn>
                </v-col>
                <!-- 对账单类型 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherBillType
                    v-model="bill_types"
                    :obj-type="shopsOptions.obj_type"
                    :Select="(selectedIds.length) ? true : false"
                  />
                </v-col>
                <!-- 名称/称号 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="obj_name"
                    v-model="obj_name"
                    @text="obj_name = $event"
                    :label="
                      $t('billRecords.code_name', [$consts.allianceName()])
                    "
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="bill_code"
                    v-model="bill_code"
                    @text="bill_code = $event"
                    :label="$t('Receipt.Fields.bill_code')"
                  />
                </v-col>

                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('Receipt.payFlgs.title')"
                    :items="$consts.financeStatus"
                    v-model="pay_flg"
                  />
                </v-col>
                <!-- 对账状态 -->
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    :label="$t('Receipt.billCheckFlg.title')"
                    :items="$consts.billCheckFlg"
                    v-model="bill_check_flg"
                  />
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>

        <!-- 已选对象 -->
        <div class="mx-4 mb-4">
          <v-expansion-panels v-model="selectedShow" multiple :disabled="selectedObj.length == 0" >
            <v-expansion-panel>
              <v-expansion-panel-header>
                <v-card-title class="ms-n4 py-0">
                  {{ $t("paymentBat.Fields.selectedObj") }}
                  <span v-if="selectedObj.length > 0">
                    {{ $t("paymentBat.Fields.confirmWithChooseCount", [selectedObj.length]) }}
                  </span>
                  <v-spacer />
                </v-card-title>
              </v-expansion-panel-header>
              <v-divider />
              <v-expansion-panel-content>
                <v-data-table
                  :headers="shopsHeaders"
                  :items="selectedObj"
                  multi-sort
                  disable-pagination
                  hide-default-footer
                  class="elevation-1 px-4 pt-1"
                >
                  <template v-slot:item.actions="{ item }">
                    <v-btn
                      small
                      text
                      class="danger--text pa-0"
                      @click="
                        selectedObj.splice(selectedObj.findIndex((shop) => shop.id == item.id ), 1);
                        selectedIds.splice(selectedIds.findIndex((shop) => shop == item.id ), 1);
                        getReceiptFromAPI()
                      "
                    >
                      <v-icon>fa-times</v-icon>
                    </v-btn>
                  </template>
                </v-data-table>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <div class="mx-4 mb-4">
          <v-data-table
            v-model="showSelect"
            show-select
            :headers="headers"
            :items="bills"
            :options.sync="options"
            :loading="loading"
            :page.sync="paging.page"
            :server-items-length="paging.count"
            multi-sort
            class="elevation-1 px-4 pt-1"
            :footer-props="$t('$config.footer-props')"
          >
            <template v-slot:item.total_price="{ item }">
              {{ $t("Global.money") }}
              {{ item.total_price | formatMoney }}
            </template>
            <template v-slot:item.wait_fee="{ item }">
              <span v-if="item.bill_type == '102' || item.bill_type == '201'">
                {{
                  Math.abs(item.total_price - (item.down_sum - item.up_sum))
                    | formatMoney
                }}
              </span>
              <span v-else>
                {{
                  Math.abs(item.total_price - (item.up_sum - item.down_sum))
                    | formatMoney
                }}
              </span>
              <!-- {{ $t("Global.money") }}
              {{
                (item.total_price - (item.up_sum - item.down_sum)) | formatMoney
              }} -->
            </template>
            <template v-slot:item.bill_check_flg="{ item }">
              <v-chip
                small
                label
                :color="item.bill_check_flg | billCheckFlgColor"
                :text-color="item.bill_check_flg | billCheckFlgTextColor"
              >
                {{ item.bill_check_flg | billCheckFlgText }}
              </v-chip>
            </template>
            <template v-slot:item.pay_flg="{ item }">
              <v-chip
                small
                label
                :color="item.pay_flg | financeFlgsColor"
                :text-color="item.pay_flg | financeFlgsTextColor"
              >
                {{ item.pay_flg | financeFlgsText }}
              </v-chip>
            </template>
            <template v-slot:item.created="{ item }">
              <span
                class="text-no-wrap caption secondary--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
              >
                {{ item.created | formatTime }}
              </span>
            </template>
          </v-data-table>
        </div>
      </v-sheet>
    </v-slide-x-transition>

    <DialogObjs
      v-model="dialog"
      :objOptions="shopsOptions"
      :shopSelectedObj="selectedObj"
      :shopSelected="selectedIds"
      @selectedObj="selectedObj = $event"
      @selectedIds="selectedIds = $event"
      @objOptions="shopsOptions = $event"
    ></DialogObjs>

    <!-- 单对象批量支付 -->
    <v-dialog persistent v-model="addDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("paymentBat.title") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="addDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <!-- 账单总金额 -->
                <v-col cols="6">
                  <span>
                    {{ $t("paymentBat.sum_price") + $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ total_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 门店 -->
                <v-col cols="6">
                  <span v-if="shopsOptions.obj_type == 1">
                    {{
                      $t("paymentBat.shop", [$consts.shopName()]) +
                      $t("Global.colon")
                    }}
                  </span>
                  <span v-else>
                    {{ $t("paymentBat.suppliers") + $t("Global.colon") }}
                  </span>
                  <span>
                    {{ shops_select_name }}
                  </span>
                </v-col>
                <!-- 总已收 -->
                <v-col cols="6" v-if="bill_types == 101 || bill_types == 202">
                  <span>
                    {{ $t("paymentBat.received") + $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ (up_sum - down_sum) | formatMoney }}
                  </span>
                </v-col>
                <!-- 总待收 -->
                <v-col cols="6" v-if="bill_types == 101 || bill_types == 202">
                  <span>
                    {{ $t("paymentBat.due_in") + $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ wait_receive_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 总已付 -->
                <v-col cols="6" v-if="bill_types == 102 || bill_types == 201">
                  <span>
                    {{ $t("paymentBat.paid") + $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ (down_sum - up_sum) | formatMoney }}
                  </span>
                </v-col>
                <!-- 总待付 -->
                <v-col cols="6" v-if="bill_types == 102 || bill_types == 201">
                  <span>
                    {{ $t("paymentBat.due_out") + $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money") }}{{ wait_pay_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 日期 -->
                <v-col cols="6">
                  <span>
                    {{ $t("paymentBat.date") + $t("Global.colon") }}
                    <SearcherDatetime
                      v-model="bill_record_time"
                      class="my-n2"
                      type="date"
                      dense
                      hide-details
                    />
                  </span>
                </v-col>
                <!-- 支付金额 -->
                <v-col cols="12">
                  <span
                    class="d-flex"
                    v-if="bill_types == 102 || bill_types == 201"
                  >
                    {{ $t("ReceiptDetail.receipt.pay_price")
                    }}{{ $t("Global.colon") }}

                    <v-text-field
                      v-model="batchPay.batch_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                  </span>
                  <span class="d-flex" v-else>
                    {{ $t("ReceiptDetail.receipt.receive_price")
                    }}{{ $t("Global.colon") }}

                    <v-text-field
                      v-model="batchPay.batch_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                  </span>
                </v-col>
                <!-- 支付方式 -->
                <v-col cols="12" v-if="bill_types == 102 || bill_types == 101">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.payment_method")
                    }}{{ $t("Global.colon") }}

                    <v-select
                      style="padding-top: 0px"
                      v-model="batchPay.pay_type"
                      :items="$consts.billTypeReceipt"
                      item-text="text"
                      clearable
                    ></v-select>
                  </span>
                </v-col>
                <v-col cols="12" v-else>
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.payment_method")
                    }}{{ $t("Global.colon") }}
                    <v-select
                      style="padding-top: 0px"
                      v-model="batchPay.pay_type"
                      :items="$consts.payTypeReceipt"
                      item-text="text"
                      clearable
                    ></v-select>
                  </span>
                </v-col>
                <!-- 账户余额 -->
                <v-col
                  cols="12"
                  v-if="
                    (bill_types == 102 || bill_types == 101) &&
                    (batchPay.pay_type == 101 || batchPay.pay_type == null)
                  "
                >
                  <span>
                    {{ $t("ReceiptDetail.receipt.balance")
                    }}{{ $t("Global.colon") }}
                  </span>
                  <span>
                    {{ $t("Global.money") }}
                    {{ shopBalance | formatMoney }}
                  </span>
                </v-col>
                <!-- 凭证号 -->
                <v-col
                  cols="12"
                  v-if="
                    (shopsOptions.obj_type == 1 &&
                      batchPay.pay_type != 101 &&
                      batchPay.pay_type != null) ||
                    (shopsOptions.obj_type == 2 &&
                      batchPay.pay_type != 101 &&
                      batchPay.pay_type != null)
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.code")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="batchPay.voucher_code"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
                <!-- 备注 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.comment")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="batchPay.comment"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="addDialog = false">{{
            $t("$vuetify.close")
          }}</v-btn>
          <v-btn
            :disabled="(batchPay.pay_type == 101 && shopBalance == 0) || !batchPay.pay_type"
            color="accent"
            @click="add()">
            {{ $t("CRUD.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- 多对象批量支付 -->
    <v-dialog persistent v-model="addsDialog" width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            {{ $t("paymentBat.title") }}
          </span>
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon v-bind="attrs" v-on="on" @click="addsDialog = false">
                fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("$vuetify.close") }}
            </span>
          </v-tooltip>
        </v-card-title>

        <v-card-text>
          <v-container>
            <v-form>
              <v-row>
                <!-- 账单总金额 -->
                <v-col cols="6">
                  <span>
                    {{ $t("paymentBat.sum_price") + $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ total_price | formatMoney }}
                  </span>
                </v-col>
                <v-col cols="6"></v-col>
                <!-- 总已收 -->
                <v-col cols="6" v-if="bill_types == 101 || bill_types == 202">
                  <span>
                    {{ $t("paymentBat.received") + $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ (up_sum - down_sum) | formatMoney }}
                  </span>
                </v-col>
                <!-- 总待收 -->
                <v-col cols="6" v-if="bill_types == 101 || bill_types == 202">
                  <span>
                    {{ $t("paymentBat.due_in") + $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money")
                    }}{{ wait_receive_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 总已付 -->
                <v-col cols="6" v-if="bill_types == 102 || bill_types == 201">
                  <span>
                    {{ $t("paymentBat.paid") + $t("Global.colon") }}
                  </span>
                  <span class="green--text">
                    {{ $t("Global.money") }}{{ (down_sum - up_sum) | formatMoney }}
                  </span>
                </v-col>
                <!-- 总待付 -->
                <v-col cols="6" v-if="bill_types == 102 || bill_types == 201">
                  <span>
                    {{ $t("paymentBat.due_out") + $t("Global.colon") }}
                  </span>
                  <span class="red--text">
                    {{ $t("Global.money") }}{{ wait_pay_price | formatMoney }}
                  </span>
                </v-col>
                <!-- 日期 -->
                <v-col cols="6">
                  <span>
                    {{ $t("paymentBat.date") + $t("Global.colon") }}
                    <SearcherDatetime
                      v-model="bill_record_time"
                      class="my-n2"
                      type="date"
                      dense
                      hide-details
                    />
                  </span>
                </v-col>
                <!-- 支付金额 -->
                <v-col cols="12">
                  <span
                    class="d-flex"
                    v-if="bill_types == 102 || bill_types == 201"
                  >
                    {{ $t("ReceiptDetail.receipt.pay_price")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="batchPay.batch_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                  </span>
                  <span class="d-flex" v-else>
                    {{ $t("ReceiptDetail.receipt.receive_price")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="batchPay.batch_price"
                      single-line
                      dense
                      hide-details
                      type="number"
                      min="0"
                      :prefix="$t('Global.money')"
                    />
                  </span>
                </v-col>
                <!-- 支付方式 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.payment_method")
                    }}{{ $t("Global.colon") }}
                    <v-select
                      style="padding-top: 0px"
                      v-model="batchPay.pay_type"
                      :items="$consts.payTypeReceipt"
                      item-text="text"
                      clearable
                    ></v-select>
                  </span>
                </v-col>
                <!-- 凭证号 -->
                <v-col
                  cols="12"
                  v-if="
                    (shopsOptions.obj_type == 1 &&
                      batchPay.pay_type != 101 &&
                      batchPay.pay_type != null) ||
                    (shopsOptions.obj_type == 2 &&
                      batchPay.pay_type != 101 &&
                      batchPay.pay_type != null)
                  "
                >
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.code")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="batchPay.voucher_code"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
                <!-- 备注 -->
                <v-col cols="12">
                  <span class="d-flex">
                    {{ $t("ReceiptDetail.receipt.comment")
                    }}{{ $t("Global.colon") }}
                    <v-text-field
                      v-model="batchPay.comment"
                      single-line
                      dense
                      hide-details
                    >
                    </v-text-field>
                  </span>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" outlined @click="addsDialog = false">{{
            $t("$vuetify.close")
            }}</v-btn>
          <v-btn
                  :disabled="(!batchPay.pay_type)"
                  color="accent"
                  @click="adds()">
            {{ $t("CRUD.confirm") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- 批量支付后的提示弹窗 -->
    <v-dialog persistent v-model="confirmDialog" max-width="480px">
      <v-card>
        <v-card-title class="mx-3">
          {{ $t("$vuetify.alert") }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  confirmDialog = false;
                  successCount = 0;
                  partCount = 0;
                  unpaidCount = 0;
                  failCount = 0;
                "
              >
                fa-times
              </v-icon>
            </template>
            {{ $t("$vuetify.close") }}
          </v-tooltip>
        </v-card-title>
        <v-divider />
        <v-card-text class="px-10 py-8 text-center subtitle-1">
          <span>
            {{ $t("paymentBat.result") }}
          </span>
          <br />
          <span class="pl-4">
            {{ $t("paymentBat.success") }}
            <span class="red--text">{{ successCount }}</span>
            {{ $t("paymentBat.piece") }},
          </span>
          <br />
          <span class="pl-4">
            {{ $t("paymentBat.part") }}
            <span class="red--text">{{ partCount }}</span>
            {{ $t("paymentBat.piece") }},
          </span>
          <br />
          <span class="pl-4">
            {{ $t("paymentBat.unpaid") }}
            <span class="red--text">{{ unpaidCount }}</span>
            {{ $t("paymentBat.piece") }}(金额不足),
          </span>
          <br />
          <span class="pl-4">
            {{ $t("paymentBat.fail") }}
            <span class="red--text">{{ failCount }}</span>
            {{ $t("paymentBat.piece") }},
          </span>
          <br />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="secondary"
            outlined
            @click="
              confirmDialog = false;
              successCount = 0;
              partCount = 0;
              unpaidCount = 0;
              failCount = 0;
            "
          >
            {{ $t("$vuetify.close") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import SearcherStatus from "@/components/plugins/SearcherStatus";
import { mapState } from "vuex";
import SearcherBillType from "./plugins/SearcherBillType";
import Receipt from "@/api/receipt";
import Shops from "@/api/shops";
import SearcherDatetime from "@/components/plugins/SearcherDatetime";
import DialogObjs from "./plugins/DialogObjs";

const defaultDatetimeRage = {
  datetimeRadioSelected: "created",
  created_time_from: new Date(new Date().getTime() - 30 * 24 * 3600 * 1000).toISOString().substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  purchase_time_from: "",
  purchase_time_to: "",
}

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from: new Date(new Date().getTime() - 30 * 24 * 3600 * 1000).toISOString().substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  actual_time_from: "",
  actual_time_to: "",
  purchase_time_from: "",
  purchase_time_to: "",
  obj_name: "",
  bill_code: "",
  pay_flg: [1, 2],
  bill_check_flg: [0, 1],
};

const defaultShopsOptions = {
  obj_type: 1,
  shop_name: "",
  shop_code: "",
  shop_user_name: "",
  login_user_id: "",
  supplier_name: "",
  supplier_code: "",
  supplier_user_name: "",
  district_id: "",
};

export default {
  data: () => ({
    showSelect: [],
    datetimeRage: JSON.parse(JSON.stringify(defaultDatetimeRage)),
    options: JSON.parse(JSON.stringify(defaultOptions)),
    shopsOptions: JSON.parse(JSON.stringify(defaultShopsOptions)),
    obj_name: "",
    bill_code: "",
    pay_flg: [1, 2],
    bill_check_flg: [0, 1],

    bill: {},

    bills: [],
    paging: {},
    dialog: false,
    addDialog: false,
    addsDialog: false,
    districtSelected: null,

    bill_record_time: new Date().toISOString().substr(0, 10),
    batchPay: {},
    total_price: 0, //账单总金额
    up_sum: 0, //总已收
    down_sum: 0, //总已付
    wait_pay_price: 0, //总待付
    wait_receive_price: 0, //总待收
    bill_types: 101,
    billIds: [],
    confirmDialog: false,
    successCount: 0,
    partCount: 0,
    unpaidCount: 0,
    failCount: 0,
    selectedObj: [],
    selectedIds: [],
    selectedShow: [],
    shopBalance: 0,
    shops_select_name: '',
  }),

  components: {
    Breadcrumbs,
    PageAllow,
    SearcherDatetimeRangeWithRadio,
    SearcherKeyword,
    SearcherStatus,
    SearcherBillType,
    SearcherDatetime,
    DialogObjs
  },

  computed: {
    itemLabel() {
      let itemLabel = '';
      if (this.shopsOptions.obj_type == 1) {
        this.selectedObj.forEach((obj) => {
          itemLabel += obj.shop_name + ';'
        });
      } else {
        this.selectedObj.forEach((obj) => {
          itemLabel += obj.supplier_name + ';'
        });
      }
      return itemLabel;
    },
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.fundManagement"),
        disabled: false,
        href: "/receipts",
      },
      {
        text: i18n.t("Nav.paymentBatch"),
        disabled: true,
        href: "/payment-batch",
      },
    ],
    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("paymentBat.Fields.created_time"),
      },
      {
        key: "actual",
        text: i18n.t("paymentBat.Fields.actual_time"),
      },
      {
        key: "purchase",
        text: i18n.t("paymentBat.Fields.purchase_time"),
      },
    ],
    headers: () => [
      {
        text: i18n.t("paymentBat.Fields.bill_code"),
        align: "start",
        sortable: false,
        value: "bill_code",
      },
      {
        text: i18n.t("paymentBat.Fields.org_code"),
        align: "start",
        sortable: false,
        value: "org_code",
      },
      {
        text: i18n.t("paymentBat.Fields.fee"),
        align: "end",
        sortable: false,
        value: "total_price",
      },
      {
        text: i18n.t("paymentBat.Fields.wait_fee"),
        align: "end",
        sortable: false,
        value: "wait_fee",
      },
      {
        text: i18n.t("paymentBat.Fields.bill_check_flg"),
        align: "start",
        sortable: false,
        value: "bill_check_flg",
      },
      {
        text: i18n.t("paymentBat.Fields.pay_flg"),
        align: "start",
        sortable: false,
        value: "pay_flg",
      },
      {
        text: i18n.t("paymentBat.Fields.created_time"),
        align: "start",
        sortable: false,
        value: "created",
      },
    ],
    shopsHeaders() {
      var shopsHeaders = [];
      if (this.shopsOptions.obj_type == 1) {
        shopsHeaders.push(
          {
            text: i18n.t("paymentBat.obj.Fields.shop_name"),
            align: "start",
            sortable: false,
            value: "shop_name",
          },
          {
            text: i18n.t("paymentBat.obj.Fields.shop_code"),
            align: "start",
            sortable: false,
            value: "shop_code",
          },
          {
            text: i18n.t("paymentBat.obj.Fields.district"),
            align: "start",
            sortable: false,
            value: "district.name",
          }
        );
      } else {
        shopsHeaders.push(
          {
            text: i18n.t("paymentBat.obj.Fields.supplier_name"),
            align: "start",
            sortable: false,
            value: "supplier_name",
          },
          {
            text: i18n.t("paymentBat.obj.Fields.supplier_code"),
            align: "start",
            sortable: false,
            value: "supplier_code",
          },
          {
            text: i18n.t("paymentBat.obj.Fields.district"),
            align: "start",
            sortable: false,
            value: "district.name",
          }
        );
      }
      shopsHeaders.push(
        {
          text: i18n.t("paymentBat.obj.Fields.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        },
      );
      return shopsHeaders;
    },
    ...mapState(["loading"]),
  },

  methods: {
    addPay() {
      this.addDialog = true;
      this.batchPay = {};
      this.bill_record_time = new Date().toISOString().substr(0, 10);
      this.shops_select_name = this.shopsOptions.obj_type == 1 ? this.selectedObj[0].shop_name : this.selectedObj[0].supplier_name;
      Shops.fetchOne(this.selectedObj[0].id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.shopBalance = response.data.shop.balance
          }
        }.bind(this)
      );
      var batch_price =
        this.bill_types == 101 || this.bill_types == 202
          ? this.wait_receive_price
          : this.wait_pay_price;
      var pay_type = this.shopsOptions.obj_type == 1 ? 101 : 102;
      this.batchPay = Object.assign({}, this.batchPay, {
        batch_price: batch_price,
        pay_type: pay_type,
      });
    },
    addPays() {
      this.addsDialog = true;
      this.batchPay = {};
      this.bill_record_time = new Date().toISOString().substr(0, 10);
      var batch_price =
        this.bill_types == 101 || this.bill_types == 202
          ? this.wait_receive_price
          : this.wait_pay_price;
      var pay_type = 102;
      this.batchPay = Object.assign({}, this.batchPay, {
        batch_price: batch_price,
        pay_type: pay_type,
      });
    },
    onSearch() {
      this.options = Object.assign({}, this.options, {
        obj_name: this.obj_name,
        bill_code: this.bill_code,
      });
    },
    resetSearch() {
      this.datetimeRage = JSON.parse(JSON.stringify(defaultDatetimeRage));
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      this.shopsOptions = JSON.parse(JSON.stringify(defaultShopsOptions));
      this.obj_name = "";
      this.bill_code = "";
      this.pay_flg = [1, 2];
      this.bill_check_flg = [0, 1];
      this.bills = [];
      this.paging = {};
      this.selectedShow = [];
      this.selectedObj = [];
      this.selectedIds = [];
      this.showSelect = [];
    },
    getReceiptFromAPI() {
      if (this.selectedObj.length == 0) {
        this.bills = [];
        this.paging = {};
        return;
      }
      if (this.shopsOptions.obj_type == 1) {
        Receipt.fetch(
          Object.assign(
            { obj_type: this.shopsOptions.obj_type },
            this.options,
            {
              shop_ids: this.selectedIds,
              cancel_flgs: 0,
              bill_types: this.bill_types,
            }
          )
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.bills = response.data.bills.filter((e) => e.pay_flg != 3);

              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
          }.bind(this)
        );
      } else if (this.shopsOptions.obj_type == 2) {
        Receipt.fetch(
          Object.assign(
            { obj_type: this.shopsOptions.obj_type },
            this.options,
            {
              supplier_ids: this.selectedIds,
              cancel_flgs: 0,
              bill_types: this.bill_types,
            }
          )
        ).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.bills = response.data.bills.filter((e) => e.pay_flg != 3);

              this.paging = response.data.paging;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
          }.bind(this)
        );
      }
    },
    add() {
      this.$store.dispatch("fullscreenLoading");
      // 判断支付金额，金额没有填写时弹出提示
      if (!this.batchPay.batch_price && this.batchPay.batch_price != 0) {
        this.$snackbar.error(i18n.t("paymentBat.notNullMoney"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else if (!this.batchPay.pay_type && this.batchPay.pay_type != '') {
        this.$snackbar.error(i18n.t("paymentBat.notNullPayType"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else if (this.billIds.length && this.batchPay.batch_price > 0) {
        var data = {
          bill_id: this.billIds[0],
          pay_type: this.batchPay.pay_type,
          comment: this.batchPay.comment,
          voucher_code: this.batchPay.voucher_code,
          bill_record_time: this.bill_record_time,
          batch_pay: 1,
          batch_price: this.batchPay.batch_price, //支付金额
        };

        Receipt.saveBillRecord(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              var bill_id = response.data.bill_record.bill_id;
              var price = response.data.bill_record.price;
              var wait_price = 0;
              this.getReceiptFromAPI();
              // 获取账单待收付的钱，判断是部分支付还是成功支付
              this.bills.forEach((e) => {
                if (
                  e.id == bill_id &&
                  (this.bill_types == 101 || this.bill_types == 202)
                ) {
                  wait_price = e.wait_receive_price;
                } else if (
                  e.id == bill_id &&
                  (this.bill_types == 102 || this.bill_types == 201)
                ) {
                  wait_price = e.wait_pay_price;
                }
              });
              if (price < wait_price) {
                ++this.partCount;
              } else {
                ++this.successCount;
              }
              this.addDialog = false;
            } else {
              ++this.failCount;
              this.getReceiptFromAPI();
            }
            this.batchPay.batch_price = response.data.batch_price;
            this.billIds.splice(0, 1);
            this.add();
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      } else {
        this.unpaidCount = this.billIds.length;
        this.$store.dispatch("fullscreenLoadingStop");
        this.addDialog = false;
        this.confirmDialog = true;
        this.showSelect = [];
        this.getReceiptFromAPI();
      }
    },
    adds() {
      this.$store.dispatch("fullscreenLoading");
      // 判断支付金额，金额没有填写时弹出提示
      if (!this.batchPay.batch_price && this.batchPay.batch_price != 0) {
        this.$snackbar.error(i18n.t("paymentBat.notNullMoney"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else if (!this.batchPay.pay_type && this.batchPay.pay_type != '') {
        this.$snackbar.error(i18n.t("paymentBat.notNullPayType"));
        this.$store.dispatch("fullscreenLoadingStop");
      } else if (this.billIds.length && this.batchPay.batch_price > 0) {
        var data = {
          bill_id: this.billIds[0],
          pay_type: this.batchPay.pay_type,
          comment: this.batchPay.comment,
          voucher_code: this.batchPay.voucher_code,
          bill_record_time: this.bill_record_time,
          batch_pay: 1,
          batch_price: this.batchPay.batch_price, //支付金额
        };

        Receipt.saveBillRecord(data).then(
          function (response) {
            if (response.data.status.isOK()) {
              var bill_id = response.data.bill_record.bill_id;
              var price = response.data.bill_record.price;
              var wait_price = 0;
              this.getReceiptFromAPI();
              // 获取账单待收付的钱，判断是部分支付还是成功支付
              this.bills.forEach((e) => {
                if (e.id == bill_id && (this.bill_types == 101 || this.bill_types == 202)) {
                  wait_price = e.wait_receive_price;
                } else if (e.id == bill_id && (this.bill_types == 102 || this.bill_types == 201)) {
                  wait_price = e.wait_pay_price;
                }
              });
              if (price < wait_price) {
                ++this.partCount;
              } else {
                ++this.successCount;
              }
              this.addsDialog = false;
            } else {
              ++this.failCount;
              this.getReceiptFromAPI();
            }
            this.batchPay.batch_price = response.data.batch_price;
            this.billIds.splice(0, 1);
            this.adds();
            this.$store.dispatch("fullscreenLoadingStop");
          }.bind(this)
        );
      } else {
        this.unpaidCount = this.billIds.length;
        this.$store.dispatch("fullscreenLoadingStop");
        this.addsDialog = false;
        this.confirmDialog = true;
        this.showSelect = [];
        this.getReceiptFromAPI();
      }
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        if (this.selectedObj.length > 0 ){
          this.getReceiptFromAPI();
        }
      },
    },
    showSelect: {
      handler() {
        var total_price = 0;
        var up_sum = 0;
        var down_sum = 0;
        var wait_pay_price = 0;
        var wait_receive_price = 0;
        this.showSelect.forEach((e) => {
          total_price += e.total_price;
          up_sum += Number(e.up_sum);
          down_sum += Number(e.down_sum);
          wait_pay_price += e.wait_pay_price;
          wait_receive_price += e.wait_receive_price;
        });
        this.total_price = total_price.toFixed(2);
        this.up_sum = up_sum.toFixed(2);
        this.down_sum = down_sum.toFixed(2);
        this.wait_pay_price = wait_pay_price.toFixed(2);
        this.wait_receive_price = wait_receive_price.toFixed(2);
        var billIds = [];

        this.showSelect.map((e) => {
          billIds.push(e.id);
        });
        this.billIds = billIds;
      },
    },
    bill_types: {
      handler() {
        if (this.selectedObj.length > 0 ){
          this.getReceiptFromAPI();
        }
        this.showSelect = [];
      },
    },
    selectedObj: {
      handler() {
        this.showSelect = [];
      }
    },
    datetimeRage: {
      handler() {
        this.options = Object.assign({}, this.options, this.datetimeRage);
        this.showSelect = [];
      }
    },
    dialog: {
      handler() {
        if (!this.dialog) {
          this.showSelect = []
          if (this.selectedObj.length > 0 ){
            if (this.shopsOptions.obj_type == 1) {
              this.bill_types = 101;
            } else {
              this.bill_types = 201;
            }
            this.selectedShow = [0]
            this.getReceiptFromAPI();
          } else {
            this.bills = [];
            this.paging = {};
            this.selectedShow = [];
          }
        }
      }
    },
    obj_name: {
      handler() {
        this.options.obj_name = this.obj_name
        this.showSelect = [];
      }},
    bill_code: {
      handler() {
        this.options.bill_code = this.bill_code
        this.showSelect = [];
      }},
    pay_flg: {
      handler() {
        this.options.pay_flg = this.pay_flg
        this.showSelect = [];
      }},
    bill_check_flg: {
      handler() {
        this.options.bill_check_flg = this.bill_check_flg
        this.showSelect = [];
      }},
  },

  mounted() {},
};
</script>

<style>
</style>